import { Ref, onBeforeUnmount } from 'vue'

import { PLAYGAMA_VIDEO } from '@/constants/general'
import { timer } from '@/utils/helpers'

export const useVideoController = (
    options: Ref<{ videoId?: string; videoUrl?: string }>,
    videoElemRef: Ref<HTMLVideoElement | undefined>,
    isVideoVisible: Ref<boolean>,
) => {
    async function showVideo() {
        const { videoId, videoUrl } = options.value

        // if no video URL or ID is provided, do not show the video
        if (!videoUrl && !videoId) {
            return
        }

        // mount empty video element
        isVideoVisible.value = true

        // wait to prevent loading videos on every accidental mouse move over the card
        await timer(100)

        if (!videoElemRef.value) {
            return
        }

        // sync playing state with data-attribute to control css animation
        videoElemRef.value.addEventListener(
            'playing',
            () => {
                if (videoElemRef.value) {
                    videoElemRef.value.dataset.playing = 'true'
                }
            },
            { once: true },
        )

        if (videoUrl) {
            playVideoByURL(videoElemRef.value, videoUrl)
        } else if (videoId) {
            const dpr = window.devicePixelRatio
            const videoElemHeight = videoElemRef.value.getBoundingClientRect().height
            const videoFileHeight = videoElemHeight * dpr > (320 + 640) / 2 ? 640 : 320

            playVideoByURL(videoElemRef.value, PLAYGAMA_VIDEO(videoId, videoFileHeight).url)
        }
    }

    function closeVideo() {
        isVideoVisible.value = false
    }

    function playVideoByURL(videoElem: HTMLVideoElement, videoUrl: string) {
        videoElem.src = videoUrl
    }

    onBeforeUnmount(() => {
        closeVideo()
    })

    return {
        showVideo,
        closeVideo,
    }
}
